/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyForgePioHubspotIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-hubspot-prod" */ './utils').then(
			(m) => m.ForgePioHubspotIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-hubspot-prod/icon' },
);

const LazyForgePioHubspotSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-hubspot-prod-search-result" */ './utils').then(
			(m) => m.ForgePioHubspotSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-hubspot-prod/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgePioHubspotIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgePioHubspotIconComponent />
	</Suspense>
);

export const ForgePioHubspotSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyForgePioHubspotSearchResultIconComponent />
	</Suspense>
);
